import getSPI from './SPI';
export const validatePromoCode = (promotionCode, cloudId) => getSPI().fetchOk("/catalog/promotions/code/".concat(promotionCode, "/validate/").concat(cloudId));
export const redeemPromoCode = (promotionCode, cloudId) => getSPI().fetchOk("/catalog/promotions/code/".concat(promotionCode, "/redeem/").concat(cloudId), {
  method: 'POST'
});
export const getAppliedPromotions = (productName, cloudId) => getSPI().fetchOk("/catalog/promotions/view?cloudId=".concat(cloudId, "&atlassianProductName=").concat(productName));